import { s as script } from './Autocomplete-b17b168a.mjs';
export { s as OAutocomplete } from './Autocomplete-b17b168a.mjs';
import { b as registerComponent } from './plugins-0d853d1f.mjs';
import 'vue';
import './Input-563330cf.mjs';
import './Icon-e7ad13c9.mjs';
import './config.mjs';
import './helpers.mjs';
import './FormElementMixin-641da1dc.mjs';

var index = {
    install(app) {
        registerComponent(app, script);
    }
};

export { index as default };
